









































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { firebaseApp, firebaseDB, firebaseFunctions } from '@/firebase';
import { FormUser } from '@/models/User';
import moment from 'moment-timezone';
import constants from '@/utils/constants';

@Component
export default class UserAdd extends Vue {
  public accountType: Array<string> = [
    'Admin',
    'Marketing',
    'Operation',
    'Finance',
    'Management',
    'Call Center',
    'Merchant OPS',
    'Merchant MKT',
    'Runner'
  ];

  public isDisabled: boolean = false;
  public isLoading: boolean = false;
  public isModalAuthShow: boolean = false;

  public error: string = '';
  public success: string = '';
  public authenticationFor: string = 'edit';

  public form: FormUser = {
    loginId: '',
    type: 'Admin',
    username: '',
    email: '',
    password: '',
    createdAt: '',
    outletCode: []
  };
  public errorMessages = {
    custom: {
      userLogin: {
        required: 'Please fill in this field.'
      },
      userName: {
        required: 'Please input your name.'
      },
      password: {
        required: 'Please input your password.'
      },
      email: {
        required: 'Please input your email.'
      }
    }
  };

  public authForm = {
    password: ''
  };

  get isMaster() {
    return this.$store.state.isMaster;
  }

  get isAdmin() {
    if (this.$store.state.currentUser) {
      return this.$store.state.currentUser.Type === 'Admin';
    }
  }

  mounted() {
    if (this.$route.name === 'UserEdit') {
      this.isDisabled = true;

      firebaseDB
        .collection('BACKOFFICE_USERS')
        .doc(this.$route.params.id)
        .get()
        .then(doc => {
          if (doc.exists) {
            const data = doc.data();
            this.form.loginId = doc.id;
            this.form.type = data!.Type;
            this.form.username = data!.UserName;
            this.form.email = data!.Email;
            this.form.createdAt = moment(data!.CreatedAt, 'X').format(
              'DD-MMM-YYYY'
            );
            this.form.outletCode = data!.OutletCodes || [];
          }
        })
        .catch(err => {
          console.error(err);
        });
    }
  }

  // user form validation
  onSubmit(scope) {
    this.error = '';
    this.success = '';
    this.$validator.localize('en', this.errorMessages);
    this.$validator.validateAll(scope).then(valid => {
      if (valid) {
        if (this.$route.name === 'UserAdd') {
          this.addUser();
        } else if (this.$route.name === 'UserEdit') {
          this.openAuthModal('edit');
          this.authForm.password = '';
        }
      }
    });
  }
  authFormSubmit(scope) {
    this.$validator.validateAll(scope).then(valid => {
      if (valid) {
        const email = this.$store.state.currentUser.Email;
        const password = this.authForm.password;
        this.authenticateUser(email, password);
      }
    });
  }

  authenticateUser(email, password) {
    firebaseApp
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(credential => {
        return credential;
      })
      .then(user => {
        this.isModalAuthShow = false;
        if (this.authenticationFor === 'edit') {
          this.updateUser();
        } else {
          this.deleteUser();
        }
      })
      .catch(err => {
        this.isModalAuthShow = false;
        this.error = 'Incorrect password, please try again.';
        console.log(err);
      });
  }

  openAuthModal(type) {
    this.isModalAuthShow = true;
    this.authenticationFor = type;
  }

  discardChanges() {
    this.$router.push('/user');
  }

  // add user
  addUser() {
    firebaseFunctions
      .httpsCallable('createAuthUser')(this.form)
      .then(result => {
        this.isModalAuthShow = false;
        if (result.data.code === constants.STATUS_200_STRING) {
          this.getUpdateUserUid();
        } else {
          this.error = result.data.data.pop();
        }
      })
      .catch(err => {
        this.isModalAuthShow = false;
        this.error = err.message;
      });
  }

  getUpdateUserUid() {
    firebaseDB
      .collection('BACKOFFICE_USERS')
      .doc(this.form.loginId)
      .get()
      .then(doc => {
        if (doc.exists) {
          const data: any = doc.data();
          this.$store
            .dispatch('GetUserInfo', {
              user_id: this.form.loginId,
              type: this.form.type,
              email: this.form.email,
              outlet_codes: this.form.outletCode,
              uid: data.UID
            })
            .then(() => this.$router.push('/user'));
        }
      });
  }

  // edit user
  updateUser() {
    this.isLoading = true;
    firebaseFunctions
      .httpsCallable('updateAuthUser')({
        loginId: this.form.loginId,
        username: this.form.username,
        password: this.form.password,
        type: this.form.type,
        outletCode: this.form.outletCode
      })
      .then(result => {
        this.isModalAuthShow = false;
        this.isLoading = false;
        if (result.data.code === constants.STATUS_200_STRING) {
          this.getUpdateUserUid();
          this.success = 'User detail updated successfully.';
        } else {
          this.error = result.data.data.pop();
        }
      })
      .catch(err => {
        this.isModalAuthShow = false;
        this.isLoading = false;
        this.error = err.message;
      });
  }

  // delete user
  deleteUser() {
    this.error = '';
    this.success = '';

    this.isLoading = true;
    firebaseFunctions
      .httpsCallable('deleteAuthUser')({
        loginId: this.form.loginId
      })
      .then(result => {
        this.isModalAuthShow = false;
        this.isLoading = false;

        if (
          result &&
          result.data &&
          result.data.code === constants.STATUS_200_STRING
        ) {
          this.$router.back();
        } else {
          this.error = result.data.data.pop();
        }
      })
      .catch(err => {
        this.isLoading = false;
        this.isModalAuthShow = false;
        this.error = err.message;
      });
  }

  addOutletCodes() {
    this.form.outletCode.push('');
  }

  removeOutletCodes(index) {
    this.form.outletCode.splice(index, 1);
  }
}
